<template lang="pug">
  .edit-product-item-weight
    v-card.mb-2(style="border-radius: 0px" flat)
      v-layout.pa-0
        v-img.ma-2(:src="product.data.images.length > 0 ? product.data.images[0].src : require('@/assets/image_placeholder.png')" max-width="80px" width="80px" height="80px")
        v-col.mr-2.py-2.px-0
          div.product-list-title.pr-2.p1.basic800--text &#35;{{ product.data.id }} {{ product.data.name }}
          //show-more-text.product-list-description.mt-2.pr-2(:text="product.data.short_description" :html="true" max=90 style="line-height: 1.2em; min-height:48px;")
          v-row(v-if="product.updated_at" align="end")
            v-col.pb-2.pt-0
              span.c1.basic600--text Last updated on {{ product.updated_at | convertServerDate }}
          v-row(align="end")
            v-col.py-0
              div.product-list-title.c2.basic600--text {{ product.data.base_price ? product.data.base_price * $currency.multiplier :  product.data.price * $currency.multiplier | displayPrice }}
          
</template>

<script>
import { mapActions } from 'vuex'
import ShowMoreText from '@/components/ShowMoreText.vue'
export default {
  name: 'WoocommerceProductItem',
  components: { ShowMoreText },
  props: ['product'],
  data: () => ({
  }),
  methods: {
    ...mapActions([
      'showMessage'
    ])
  }
}
</script>

<style scoped>
.count-list-layout {
  position: absolute;
  right: 4px;
}
.product-list-title {
  color:#2E2E2E;
  size: 9px;
  font-weight: bold;
}
.product-list-description {
  color: #2E2E2E;
  font-size: 12px;
  white-space: pre-wrap;
}
.clickable {
  cursor: pointer;
}
</style>

<i18n>
{
  "en": {
    "weight": {
      "label": "Weight",
      "placeholder": "Min = 0.1 kg | Max = 60 kg"
    }
  },
  "id": {
    "weight": {
      "label": "Berat",
      "placeholder": "Min = 0.1 kg | Maks = 60 kg"
    }
  }
}
</i18n>